import * as swcHelpers from '@swc/helpers';
import React__default, { forwardRef } from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const LineItemContent = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { body , children , className , title  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "body",
        "children",
        "className",
        "title"
    ]);
    let content = children;
    if (!content) {
        content = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Heading, {
            variant: "smallest",
            className: "elements-line-item-content__title"
        }, title), /*#__PURE__*/ React__default.createElement("div", {
            className: "elements-line-item-content__body"
        }, body));
    }
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('elements-line-item-content', className),
        ref: ref
    }), content);
});
LineItemContent.displayName = 'LineItemContent';
var LineItemContent$1 = LineItemContent;

export { LineItemContent$1 as default };
//# sourceMappingURL=LineItemContent.js.map
